export default {
  fi: {
    ServiceEventShowScene: {
      serviceEventType: 'Huoltotyyppi',
      serviceEventServiceDate: 'Huoltopäivä',
      serviceEventMileage: 'Kilometrit',
      serviceEventRunningHours: 'Käyttötunnit',
      serviceEventDescription: 'Kuvaus',
      backLink: 'Takaisin',
      partner: 'Yritys',
      serviceEventAttachmentsInfo:
        'Voit tallentaa huoltotapahtumalle esimerkiksi kuitteja ja laskuja. Huoltotapahtumalle voi tallentaa enintään kolme liitetiedostoa.',
      serviceEventAttachmentsEmpty:
        'Huoltotapahtumalla ei ole vielä yhtään liitetiedostoa.',
    },
  },
};
